export default __webpack_public_path__ + "static/media/Avatar1.6f0e6ebf.svg";